import styled, { css } from 'styled-components';
import { ChevronDownIcon } from '@root/styles/icons';

export const DropdownIndicator = styled(ChevronDownIcon)<{ open: boolean }>`
  width: 24px;
  height: 24px;
  align-self: flex-end;
  margin-left: auto;
  transition: transform 0.25s ease;

  ${({ open }) =>
    open &&
    css`
      transform: rotate(180deg);
    `}
`;

export const ItemButton = styled.button<{ isActiveRoute: boolean }>`
  padding: 20px;
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  background: ${({ isActiveRoute, theme }) =>
    isActiveRoute ? theme.defaultColors.lighterGrey : 'none'};
  -webkit-tap-highlight-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.defaultColors.lighterGrey}`};
  width: 100%;
  cursor: pointer;
  color: ${({ theme }) => `${theme.defaultColors.fontPrimary}`};

  :focus {
    outline: none;
  }

  svg {
    margin-right: 8px;
  }

  :hover,
  :focus {
    background: ${({ theme }) => theme.defaultColors.lighterGrey};
  }
`;

export const ChildWrapper = styled.div<{ isVisible: boolean }>`
  transition: 0.5s all;
  overflow-y: auto;

  ${({ isVisible }) =>
    isVisible
      ? `
    opacity: 1;
    max-height: 2000vh;
  `
      : `
    opacity: 0;
    max-height: 0;
  `};
`;
